import { Component } from '@angular/core';
import { ProjectsTableComponent } from '../projects-table/projects-table.component';
import { SubProject } from 'src/app/model/project/sub-project';

@Component({
  selector: 'site-visit-projects',
  templateUrl: '../projects-table/projects-table.component.html',
  styleUrls: ['../projects-table/projects-table.component.scss'],
})
export class SiteVisitProjectsComponent extends ProjectsTableComponent {
  ngOnInit() {
    super.ngOnInit();
    this.projects = [];
    this.displayedColumns = [
      'project_id',
      'requestor',
      'currentCreatedAt',
      'currentRequestDate',
      'currentConfirmedPlacementDate',
      'currentSiteVisitDate',
      'company',
      'projectPlacement.address',
      'productType',
      'productSize',
      'siteVisitor',
      'displayStatus',
      'star',
    ];
  }

  protected getLocalStorageKey(): string {
    return 'SiteVisitProjectsComponent';
  }

  protected getStatusFilter(): string {
    return 'statusSubstatus/vv,Afhaling,Aanpassing,Concept,In_behandeling/Werfbezoek';
  }

  public getPageTitle(): string {
    return 'Werfbezoek';
  }

  // Override
  public getDefaultSort() {
    return 'currentSiteVisitDate';
  }

  // Override
  public showImportant(subProject: SubProject) {
    return subProject.siteVisitImportant;
  }
}
